const LOCAL_STORAGE_EVENTS = {
  FILE_IMPORTING: "FILE_IMPORTING",
  TIMESLOT_IMPORTING: "TIMESLOT_IMPORTING",
};
export default LOCAL_STORAGE_EVENTS;
